import DataTable, { TableStyles } from 'react-data-table-component';
import {
  ErisSummaryResultsModel,
  useErisInformationStore,
} from 'src/api/eris/store/ErisInformationStore';
import { columns, conditionalRowStyles } from './ErisStatusSummaryTableColumn';
import { useTranslation } from 'react-i18next';

const customStyles: TableStyles = {
  headCells: {
    style: {
      backgroundColor: 'var(--rdt-head-bg, #2e2db9)',
      color: '#ffffff',
      fontWeight: 'bold',
      borderRight: 'var(--rdt-head-brw, 2px) solid var(--rdt-head-brc, #ccc)',
      borderBottom: '2px solid #ccc',
      borderTop: '2px solid #ccc',
      fontSize: '1rem',
      whiteSpace: 'break-word',
      width: 'auto',
      minWidth: 'fit-content',
      textAlign: 'center' as const,
      justifyContent: 'center',
      display: 'flex',
    },
  },
  rows: {
    style: {
      borderBottomWidth: 0,
      borderBottomStyle: 'none',
    },
  },
  headRow: {
    style: {
      borderBottomWidth: 0,
      borderBottomStyle: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '0',
      paddingRight: '0.125rem',
      borderRight: 'var(--rdt-cell-brw, 2px) solid var(--rdt-cell-brc, #ccc)',
      borderBottom: '2px solid #ccc',
      fontSize: '1rem',
    },
  },
};

const ErisSummaryTable = () => {
  const { t } = useTranslation();
  const { statusSummaryList, isSearchingResults } = useErisInformationStore();

  const calculateSummary = () => {
    const items = [...(statusSummaryList?.groupSummaries ?? [])];
    const total: ErisSummaryResultsModel | undefined = statusSummaryList?.total;

    if (total !== undefined && !items.some((i) => i.groupName === 'TOTAL')) {
      items.push(total);
    }
    return items;
  };

  return (
    <div className="flex w-auto flex-row border-l-2 border-solid border-l-gray-300">
      <DataTable
        columns={columns(t)}
        noDataComponent={t('eris.common.noResults')}
        data={calculateSummary()}
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
        fixedHeader
        fixedHeaderScrollHeight="100%"
        progressPending={isSearchingResults}
      />
    </div>
  );
};

export default ErisSummaryTable;
